// English translations
const en = {
  translation: {
    // Common
    'app.name': 'Visual Remote Monitoring',
    'app.login': 'Login',
    'app.loginDemo': 'Demo Login',
    'app.register': 'Register',
    'app.logout': 'Logout',
    'common.dashboard': 'Dashboard',
    'common.installations': 'Installation List',
    'app.news': 'News',
    'news.overview': 'News overview',
    'news.searchPlaceholder': 'Search news...',
    'news.searchButton': 'Search',
    'news.noNewsFound': 'No news found.',
    'app.shop': 'Shop',

    // Gallery
    'gallery.title': 'Installation Gallery',
    'gallery.share': 'Share',
    'gallery.shared': 'Shared',
    'gallery.pending': 'Pending Review',
    'gallery.noImages': 'No images available',
    'gallery.like': 'Like',
    'gallery.loginToLike': 'Login to like',
    'gallery.loadError': 'Failed to load gallery',
    'common.uploadImagesSuccess': 'Upload successful',
    'common.uploadImagesFailed': 'Upload failed',
    'gallery.deleteConfirm': 'Are you sure you want to delete this image?',
    'gallery.maxImages': 'Maximum {{max}} images allowed',
    'gallery.caption': 'Image description',
    'gallery.selectInstallation': 'Select installation',
    'gallery.selectFiles': 'Select image files',
    'gallery.filesSelected': 'Selected {{count}} files',
    'gallery.selectInstallationAndFiles': 'Please select installation and image files',
    'gallery.shareToGallery': 'Share to public gallery',
    'gallery.myImages': 'My Images',
    'gallery.publicGallery': 'Public Gallery',
    'gallery.unshare': 'Unshare',
    'gallery.unshared': 'Unshared',
    'gallery.subtitle': 'Share your solar installation and inspire others',
    'gallery.dropOrClick': 'Drag images here or click to select',
    'gallery.private': 'Private',
    'gallery.selectSource': 'Select image source',
    'gallery.takePhoto': 'Take Photo',
    'gallery.chooseFromGallery': 'Choose from Gallery',
    'gallery.captionPlaceholder': 'Describe your installation...',
    'gallery.shareHint': 'Allow other users to view this photo',
    'common.uploadImagesHint': 'Supports JPG, PNG formats (max 10MB)',

    'common.devices': 'Devices',
    'app.profile': 'Profile',
    'common.settings': 'Settings',
    'settings.verificationCode': 'Verification Code',
    'settings.sendCode': 'Send Code',
    'settings.codeSentNotice': 'Verification code sent to your email',
    'settings.codeRequired': 'Please enter 6-digit verification code',
    'app.language': 'Language',

    'app.email': 'Email',
    'common.password': 'Password',
    'app.username': 'Username',
    'app.confirmPassword': 'Confirm Password',
    'app.submit': 'Submit',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.set': 'Set',
    'common.delete': 'Delete',
    'common.add': 'Add',
    'common.upload': 'Upload',
    'common.edit': 'Edit',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.sort': 'Sort',
    'common.status': 'Status',
    'common.online': 'Online',
    'common.offline': 'Offline',
    'common.error': 'Error',
    'common.success': 'Success',
    'app.back': 'Back',
    'app.home': 'Home',
    'common.actions': 'Actions',
    'common.loading': 'Loading...',
    'common.processing': 'Processing...',
    'common.close': 'Close',
    'common.units': 'Units',
    'common.normal': 'Normal',
    'common.tooHigh': 'Too High',
    'common.tooLow': 'Too Low',
    'common.number': 'Number',
    'common.time': 'Time',
    'common.overview': 'Overview',
    'common.details': 'Details',
    'common.rowsPerPage': 'Rows per page',
    'common.readMore': 'Read more',
    // Unified terms (reuse across pages)
    'common.voltage': 'Voltage',
    'common.current': 'Current',
    'common.power': 'Power',
    'common.temperature': 'Temperature',
    'common.soc': 'SOC',
    'common.charging': 'Charging',
    'common.discharging': 'Discharging',
    'common.idle': 'Idle',
    'common.warning': 'Warning',
    'common.warnState1': 'Warning State 1',
    'common.warnState2': 'Warning State 2',
    'common.cell': 'Cell',
    'common.avgVoltage': 'Average Voltage',
    'common.avgTemperature': 'Average Temperature',
    'common.totalCurrent': 'Total Current',
    'common.totalPower': 'Total Power',
    'common.fullyCharged': 'Fully Charged',
    'common.user': 'User',
    'common.deviceId': 'Device ID',
    'common.unknownWarning': 'Unknown Warning',
    'common.admin': 'Admin',
    'common.protection': 'Protection',
    'common.fault': 'Fault',
    'common.calibration': 'Calibration',
    'common.refresh': 'Refresh Data',
    'common.addDevice': 'Add Device',
    'common.deviceAdded': 'Device added successfully',
    'common.cycleCount': 'Cycle Count',
    'common.soh': 'SOH',
    'common.realtime': 'Real-time Monitoring',
    'common.batteryPackTitle': 'Battery Pack #{{index}}',
    'common.remainCapacityAh': 'Remaining Capacity (Ah)',
    'common.fullChargeCapacityAh': 'Full Capacity (Ah)',
    'common.designCapacityAh': 'Design Capacity (Ah)',
    'common.backToDetail': 'Back to Installation Details',
    'common.loadDeviceFailed': 'Failed to load device details',
    'common.permissionsManagement': 'Permissions Management',
    'common.shortCircuitProt': 'Short Circuit Protection',
    'common.startDate': 'Start Date',
    'common.endDate': 'End Date',
    // Status & States
    'common.expired': 'Expired',
    // Actions
    'common.create': 'Create',
    // Time-related
    'common.day': 'day',
    'common.days': 'days',
    'common.createdAt': 'Created At',
    'common.expiry': 'Expiry Date',
    'common.expiryDays': 'Validity Period (days)',
    // Battery-related
    'common.batteryPack': 'Battery Pack',
    'common.dischargeEnabled': 'Discharge Enabled',
    'common.chargeEnabled': 'Charge Enabled',
    'common.currentLimit': 'Current Limit',
    'common.charger': 'Charger',
    'common.avg': 'Average',


    // Device
    'device.lastConnection': 'Last Connection',
    'device.delete': 'Delete Installation',
    'device.view': 'View Device',
    'device.notFound': 'Device not found',
    'device.deleteSuccess': 'Installation deleted successfully',
    'device.confirmDelete': 'Are you sure you want to delete this installation?',
    'device.info': 'Installation Information',
    'device.details': 'Device Details',
    'device.never': 'Never',
    'device.errorMissingFields': 'Please fill in all required fields',
    'device.idHelp': 'Enter a unique ID for your device',
    'device.nameHelp': 'Give your device a name',
    'device.loading': 'Loading devices...',
    'common.justNow': 'Just now',
    'device.minutesAgo': 'minutes ago',
    'device.hoursAgo': 'hours ago',
    'device.noDevicesDesc': 'You have not added any devices yet. Click the button below to add your first device.',
    'device.deleting': 'Deleting...',
    'device.noConnections': 'No recent connections',
    'device.type': 'Device Type',
    'device.optionalInfo': 'Optional Information',
    'device.optionalInfoTooltip': 'Filling in this information helps us provide better after-sales service and technical support',
    'device.inverterBrand': 'Inverter Brand',
    'device.inverterModel': 'Inverter Model',
    'device.solarPower': 'Solar Power (kW)',
    'device.city': 'Installation City',
    'device.description': 'Installation Description',
    'device.updatedAt': 'Updated At',

    // Battery data
    'battery.status': 'Charging Status',
    'battery.data': 'Battery Data',
    'battery.history': 'History',
    'battery.protectionRecord': 'Protection Records',
    'battery.balance': 'Balance Current',
    'battery.cells': 'Cell Count',
    'battery.noData': 'No data available',
    'battery.historyCharts': 'History Charts',
    'battery.resetZoom': 'Reset',

    'battery.cellData': 'Cell Data',
    'battery.cellVoltageData': 'Cell Voltage Data',
    'battery.temperatureData': 'Temperature Sensor Data',
    'battery.cellDataUnavailable': 'Cell data temporarily unavailable, displaying previous data...',
    'battery.tempDataUnavailable': 'Temperature sensor data temporarily unavailable, displaying previous data...',
    'battery.cellVoltageTable': 'Cell Voltage Table',
    'battery.tempDataTable': 'Temperature Sensor Data Table',
    'battery.cellStats': 'Cell Statistics',
    'battery.activeBalancing': 'Active Balancing',
    'battery.activeBalancingOn': 'Balancing',
    'battery.heaterEnabled': 'Heater Enabled',
    'battery.currentLimitEnabled': 'Current Limit Enabled',
    'battery.highest': 'Highest',
    'battery.lowest': 'Lowest',
    'battery.highestVoltage': 'Highest Voltage',
    'battery.lowestVoltage': 'Lowest Voltage',
    'battery.volDiff': 'Voltage Difference',
    'battery.totalCells': 'Total Cells',
    'battery.temperatureSensors': 'Temperature Sensors',
    'battery.temperatureStats': 'Temperature Statistics',
    'battery.sensorCount': 'Sensor Count',
    'battery.highestTemperature': 'Highest Temperature',
    'battery.lowestTemperature': 'Lowest Temperature',
    'battery.faultState': 'Fault State',
    'battery.protectState1': 'Protection State 1',
    'battery.protectState2': 'Protection State 2',

    // Warning titles
    'warning.title': 'Warning Information',
    'warning.current': 'Current Warnings',
    'warning.normal': 'Current battery status is normal, no warnings',
    'warning.noWarning': 'No Warning',

    // Warning states

    // Protection state related
    'warning.protect_high_discharge_current': 'Discharge Overcurrent Protection',
    'warning.protect_high_charge_current': 'Charge Overcurrent Protection',
    'warning.protect_low_total_voltage': 'Total Undervoltage Protection',
    'warning.protect_high_total_voltage': 'Total Overvoltage Protection',
    'warning.protect_low_cell_voltage': 'Cell Undervoltage Protection',
    'warning.protect_high_cell_voltage': 'Cell Overvoltage Protection',
    'warning.protect_low_env_temp': 'Environment Low Temperature Protection',
    'warning.protect_high_env_temp': 'Environment High Temperature Protection',
    'warning.protect_high_mos_temp': 'MOS High Temperature Protection',
    'warning.protect_low_discharge_temp': 'Discharge Low Temperature Protection',
    'warning.protect_low_charge_temp': 'Charge Low Temperature Protection',
    'warning.protect_high_discharge_temp': 'Discharge High Temperature Protection',
    'warning.protect_high_charge_temp': 'Charge High Temperature Protection',

    // Command state related
    'battery.reverse_connected': 'Battery Reverse Connection',

    // Fault state related
    'warning.fault_sampling': 'Sampling Fault',
    'warning.fault_cell': 'Cell Fault',
    'warning.fault_ntc': 'Temperature Sensor Fault',
    'warning.fault_discharge_mos': 'Discharge MOS Fault',
    'warning.fault_charge_mos': 'Charge MOS Fault',
    'warning.fault_adapter_temp': 'Adapter Board Over Temperature',
    'warning.fault_virtual_connection': 'Battery Virtual Connection',
    'warning.fault_communication': 'Communication Fault',
    'warning.fault_ccb': 'CCB Fault',
    'warning.fault_heater': 'Heater Fault',
    'warning.fault_12v': '12V Power Fault',
    'warning.fault_total_voltage': 'Total Voltage Fault',
    'warning.fault_temp_diff': 'Temperature Difference Fault',
    'warning.fault_detect_resistor': 'Detection Resistor Fault',
    'warning.fault_trip_unit': 'Trip Unit Fault',
    'warning.fault_master_slave': 'Master/Slave Communication Fault',
    'warning.fault_bms_lock': 'BMS Locked',
    'warning.fault_mcu_overvoltage': 'MCU Overvoltage',

    'warning.protect_short_circuit': 'Short Circuit Protection',
    'warning.protect_charger_overvoltage': 'Charger Overvoltage Protection',
    'warning.protect_full_charge': 'Full Charge Protection',

    // Status indicators
    'status.limit_current_on': 'Current Limit ON',
    'status.limit_current_off': 'Current Limit OFF',
    'status.charge_mos_on': 'Charge MOS ON',
    'status.charge_mos_off': 'Charge MOS OFF',
    'status.discharge_mos_on': 'Discharge MOS ON',
    'status.discharge_mos_off': 'Discharge MOS OFF',
    'status.charger_connected': 'Charger Connected',
    'status.charger_disconnected': 'Charger Disconnected',
    'status.heater_on': 'Heater ON',
    'status.heater_off': 'Heater OFF',

    // Warning state 1 related
    'warning.warn_high_discharge_current': 'High Discharge Current Warning',
    'warning.warn_high_charge_current': 'High Charge Current Warning',
    'warning.warn_low_total_voltage': 'Low Total Voltage Warning',
    'warning.warn_high_total_voltage': 'High Total Voltage Warning',
    'warning.warn_low_cell_voltage': 'Low Cell Voltage Warning',
    'warning.warn_high_cell_voltage': 'High Cell Voltage Warning',

    // Warning state 2 related
    'warning.warn_low_soc': 'Low SOC Warning',
    'warning.warn_high_mos_temp': 'MOS High Temperature Warning',
    'warning.warn_low_env_temp': 'Environment Low Temperature Warning',
    'warning.warn_high_env_temp': 'Environment High Temperature Warning',
    'warning.warn_low_discharge_temp': 'Discharge Low Temperature Warning',
    'warning.warn_low_charge_temp': 'Charge Low Temperature Warning',
    'warning.warn_high_discharge_temp': 'Discharge High Temperature Warning',
    'warning.warn_high_charge_temp': 'Charge High Temperature Warning',

    // Warning states
    'warning.below_lower_limit': 'Below Lower Limit',
    'warning.above_upper_limit': 'Above Upper Limit',
    'warning.user_defined': 'User Defined Warning',
    'warning.other_fault': 'Other Fault',

    // Warning descriptions (for tooltip)
    'warningDesc.warn_low_soc': 'Battery SOC is below the safe threshold, please charge in time',
    'warningDesc.warn_high_mos_temp': 'MOS temperature is too high, which may affect charging/discharging efficiency',
    'warningDesc.warn_low_env_temp': 'Environment temperature is too low, which may affect battery performance',
    'warningDesc.warn_high_env_temp': 'Environment temperature is too high, please pay attention to heat dissipation',
    'warningDesc.warn_low_discharge_temp': 'Discharge temperature is too low, discharge has been limited',
    'warningDesc.warn_low_charge_temp': 'Charge temperature is too low, charge has been limited',
    'warningDesc.warn_high_discharge_temp': 'Discharge temperature is too high, discharge has been limited',
    'warningDesc.warn_high_charge_temp': 'Charge temperature is too high, charge has been limited',
    'warningDesc.warn_high_discharge_current': 'Discharge current exceeds the safety limit',
    'warningDesc.warn_high_charge_current': 'Charge current exceeds the safety limit',
    'warningDesc.warn_low_total_voltage': 'Total voltage is below the safe threshold',
    'warningDesc.warn_high_total_voltage': 'Total voltage is above the safe threshold',
    'warningDesc.warn_low_cell_voltage': 'Cell voltage is too low',
    'warningDesc.warn_high_cell_voltage': 'Cell voltage is too high',
    'warningDesc.protect_high_discharge_current': 'Discharge current is too high, protection triggered',
    'warningDesc.protect_high_charge_current': 'Charge current is too high, protection triggered',
    'warningDesc.protect_short_circuit': 'Short circuit detected, protection triggered',
    'warningDesc.protect_low_total_voltage': 'Total voltage is too low, protection triggered',
    'warningDesc.protect_high_total_voltage': 'Total voltage is too high, protection triggered',
    'warningDesc.protect_low_cell_voltage': 'Cell voltage is too low, protection triggered',
    'warningDesc.protect_high_cell_voltage': 'Cell voltage is too high, protection triggered',
    'warningDesc.protect_low_env_temp': 'Environment temperature is too low, protection triggered',
    'warningDesc.protect_high_env_temp': 'Environment temperature is too high, protection triggered',
    'warningDesc.protect_high_mos_temp': 'MOS temperature is too high, protection triggered',
    'warningDesc.protect_low_discharge_temp': 'Discharge temperature is too low, protection triggered',
    'warningDesc.protect_low_charge_temp': 'Charge temperature is too low, protection triggered',
    'warningDesc.protect_high_discharge_temp': 'Discharge temperature is too high, protection triggered',
    'warningDesc.protect_high_charge_temp': 'Charge temperature is too high, protection triggered',
    'warningDesc.fault_sampling': 'Battery sampling circuit is abnormal, please check the hardware',
    'warningDesc.fault_cell': 'Battery cell fault, please check the battery pack',
    'warningDesc.fault_ntc': 'Temperature sensor fault, unable to accurately measure temperature',
    'warningDesc.fault_discharge_mos': 'Discharge MOS fault, unable to discharge normally',
    'warningDesc.fault_charge_mos': 'Charge MOS fault, unable to charge normally',
    'warningDesc.fault_adapter_temp': 'Adapter board temperature is too high',
    'warningDesc.fault_virtual_connection': 'Battery contact is poor, please check the connection',

    // Charging status constants

    // Authentication
    'auth.loginTitle': 'Login to your account',
    'auth.registerTitle': 'Create new account',
    'auth.forgotPassword': 'Forgot password?',
    'auth.noAccount': 'Don\'t have an account?',
    'auth.haveAccount': 'Already have an account?',
    'auth.loginSuccess': 'Login successful',
    'auth.registerSuccess': 'Registration successful',
    'auth.registerFailed': 'Registration failed',
    'auth.logoutSuccess': 'Logout successful',
    'auth.invalidCredentials': 'Invalid email or password',
    'auth.passwordMismatch': 'Password does not match',
    'auth.emailExists': 'Email already exists',
    'auth.usernameExists': 'Username already exists',
    'auth.managerEmail': 'Admin email (optional)',
    'auth.managerEmailHelp': 'If you know your admin\'s email, enter it here to join their team',
    'auth.invitationCode': 'Invitation code (optional)',
    'auth.invitationCodeHelp': 'If you have an invitation code, enter it here',
    'auth.forgotPasswordDesc': 'Please enter your registered email address and we will send you a link to reset your password.',
    'auth.forgotPasswordSuccess': 'Reset email sent. Please check your inbox.',
    'auth.invalidToken': 'Invalid Token',
    'auth.tokenErrorDesc': 'Invalid or missing reset token. Please access this page from your email link.',
    'auth.passwordUpdated': 'Password reset successfully. Redirecting to login...',
    'auth.resetPasswordTitle': 'Reset Password',

    // Settings
    'settings.about': 'About',
    'settings.aboutDesc': 'Home Battery IoT is a home battery device monitoring system.',
    'settings.languageUpdated': 'Language updated successfully',
    'settings.updateFailed': 'Failed to update settings',
    'settings.changePassword': 'Change Password',
    'settings.currentPassword': 'Current Password',
    'settings.newPassword': 'New Password',
    'settings.confirmPassword': 'Confirm New Password',
    'settings.passwordUpdated': 'Password changed successfully',
    'settings.passwordMismatch': 'Passwords do not match',
    'settings.passwordTooShort': 'Password must be at least 6 characters',
    'settings.usernameUpdated': 'Username updated successfully',
    'settings.appearance': 'Appearance Settings',
    'settings.avatar': 'Avatar',
    'settings.changeAvatar': 'Change Avatar',
    'settings.avatarHint': 'Max 2MB, supports JPG/PNG/GIF/WebP formats',
    'settings.avatarUpdated': 'Avatar updated successfully',
    'settings.invalidFileType': 'Please select an image file',
    'settings.fileTooLarge': 'File is too large, maximum supported size is 2MB',
    'settings.timezone': 'Timezone',
    'settings.timezoneUpdated': 'Timezone updated successfully',

    // Timezone labels
    'timezones.UTC': 'UTC (Coordinated Universal Time)',
    'timezones.Europe/London': 'London (GMT/BST)',
    'timezones.Europe/Dublin': 'Dublin (GMT/IST)',
    'timezones.Europe/Paris': 'Paris (CET/CEST)',
    'timezones.Europe/Berlin': 'Berlin (CET/CEST)',
    'timezones.Europe/Amsterdam': 'Amsterdam (CET/CEST)',
    'timezones.Europe/Brussels': 'Brussels (CET/CEST)',
    'timezones.Europe/Rome': 'Rome (CET/CEST)',
    'timezones.Europe/Madrid': 'Madrid (CET/CEST)',
    'timezones.Europe/Lisbon': 'Lisbon (WET/WEST)',
    'timezones.Europe/Vienna': 'Vienna (CET/CEST)',
    'timezones.Europe/Zurich': 'Zurich (CET/CEST)',
    'timezones.Europe/Stockholm': 'Stockholm (CET/CEST)',
    'timezones.Europe/Oslo': 'Oslo (CET/CEST)',
    'timezones.Europe/Copenhagen': 'Copenhagen (CET/CEST)',
    'timezones.Europe/Helsinki': 'Helsinki (EET/EEST)',
    'timezones.Europe/Warsaw': 'Warsaw (CET/CEST)',
    'timezones.Europe/Prague': 'Prague (CET/CEST)',
    'timezones.Europe/Athens': 'Athens (EET/EEST)',
    'timezones.Europe/Istanbul': 'Istanbul (TRT)',
    'timezones.Europe/Moscow': 'Moscow (MSK)',
    'timezones.America/New_York': 'New York (EST/EDT)',
    'timezones.America/Toronto': 'Toronto (EST/EDT)',
    'timezones.America/Chicago': 'Chicago (CST/CDT)',
    'timezones.America/Denver': 'Denver (MST/MDT)',
    'timezones.America/Phoenix': 'Phoenix (MST)',
    'timezones.America/Los_Angeles': 'Los Angeles (PST/PDT)',
    'timezones.America/Vancouver': 'Vancouver (PST/PDT)',
    'timezones.America/Anchorage': 'Anchorage (AKST/AKDT)',
    'timezones.Pacific/Honolulu': 'Honolulu (HST)',
    'timezones.America/Mexico_City': 'Mexico City (CST/CDT)',
    'timezones.America/Bogota': 'Bogota (COT)',
    'timezones.America/Lima': 'Lima (PET)',
    'timezones.America/Santiago': 'Santiago (CLT/CLST)',
    'timezones.America/Sao_Paulo': 'Sao Paulo (BRT)',
    'timezones.America/Buenos_Aires': 'Buenos Aires (ART)',
    // Middle East
    'timezones.Asia/Jerusalem': 'Jerusalem (IST)',
    'timezones.Asia/Beirut': 'Beirut (EET/EEST)',
    'timezones.Asia/Amman': 'Amman (EET/EEST)',
    'timezones.Asia/Baghdad': 'Baghdad (AST)',
    'timezones.Asia/Kuwait': 'Kuwait (AST)',
    'timezones.Asia/Dubai': 'Dubai (GST)',
    'timezones.Asia/Muscat': 'Muscat (GST)',
    'timezones.Asia/Riyadh': 'Riyadh (AST)',
    'timezones.Asia/Qatar': 'Doha (AST)',
    'timezones.Asia/Bahrain': 'Bahrain (AST)',
    'timezones.Asia/Tehran': 'Tehran (IRST)',
    // Central Asia
    'timezones.Asia/Kabul': 'Kabul (AFT)',
    'timezones.Asia/Karachi': 'Karachi (PKT)',
    'timezones.Asia/Tashkent': 'Tashkent (UZT)',
    'timezones.Asia/Almaty': 'Almaty (ALMT)',
    // South Asia
    'timezones.Asia/Kolkata': 'Mumbai / New Delhi (IST)',
    'timezones.Asia/Colombo': 'Colombo (IST)',
    'timezones.Asia/Kathmandu': 'Kathmandu (NPT)',
    'timezones.Asia/Dhaka': 'Dhaka (BST)',
    'timezones.Asia/Yangon': 'Yangon (MMT)',
    // Southeast Asia
    'timezones.Asia/Bangkok': 'Bangkok (ICT)',
    'timezones.Asia/Ho_Chi_Minh': 'Ho Chi Minh City (ICT)',
    'timezones.Asia/Jakarta': 'Jakarta (WIB)',
    'timezones.Asia/Singapore': 'Singapore (SGT)',
    'timezones.Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
    'timezones.Asia/Manila': 'Manila (PHT)',
    // East Asia
    'timezones.Asia/Hong_Kong': 'Hong Kong (HKT)',
    'timezones.Asia/Shanghai': 'Shanghai / Beijing (CST)',
    'timezones.Asia/Taipei': 'Taipei (CST)',
    'timezones.Asia/Seoul': 'Seoul (KST)',
    'timezones.Asia/Tokyo': 'Tokyo (JST)',
    // Oceania
    'timezones.Australia/Perth': 'Perth (AWST)',
    'timezones.Australia/Adelaide': 'Adelaide (ACST/ACDT)',
    'timezones.Australia/Brisbane': 'Brisbane (AEST)',
    'timezones.Australia/Sydney': 'Sydney (AEST/AEDT)',
    'timezones.Australia/Melbourne': 'Melbourne (AEST/AEDT)',
    'timezones.Pacific/Auckland': 'Auckland (NZST/NZDT)',
    // Africa (North)
    'timezones.Africa/Casablanca': 'Casablanca (WET/WEST)',
    'timezones.Africa/Algiers': 'Algiers (CET)',
    'timezones.Africa/Tunis': 'Tunis (CET)',
    'timezones.Africa/Tripoli': 'Tripoli (EET)',
    'timezones.Africa/Cairo': 'Cairo (EET)',
    // Africa (East)
    'timezones.Africa/Khartoum': 'Khartoum (CAT)',
    'timezones.Africa/Addis_Ababa': 'Addis Ababa (EAT)',
    'timezones.Africa/Nairobi': 'Nairobi (EAT)',
    // Africa (West)
    'timezones.Africa/Lagos': 'Lagos (WAT)',
    'timezones.Africa/Accra': 'Accra (GMT)',
    // Africa (South)
    'timezones.Africa/Johannesburg': 'Johannesburg (SAST)',
    'timezones.Africa/Cape_Town': 'Cape Town (SAST)',

    'common.uploading': 'Uploading...',

    // Errors
    'error.pageNotFound': 'Page Not Found',
    'error.pageNotFoundDesc': 'The page you are looking for may have been deleted, renamed, or is temporarily unavailable.',
    'error.fetchFailed': 'Failed to fetch data',
    'error.createFailed': 'Failed to create',
    'error.copyFailed': 'Failed to copy',
    'error.processFailed': 'Failed to process request',

    // Admin
    'admin.dashboard': 'Admin Dashboard',
    'admin.superDashboard': 'Superadmin Dashboard',
    'admin.managedUsers': 'Managed Users',
    'admin.managedDevices': 'Managed Devices',
    'admin.role': 'Role',
    'admin.superadmin': 'Superadmin',
    'admin.noUsers': 'No users found',
    'admin.userList': 'User List',
    'admin.adminList': 'Admin List',
    'admin.deviceList': 'Device List',
    'admin.noAdmins': 'No admins found',
    'admin.addAdmin': 'Add Admin',
    'admin.createError': 'Create admin error',
    'admin.fillAllFields': 'Please fill in all fields',
    'admin.deviceCount': 'Device Count',
    'admin.assignManager': 'Assign Admin',
    'admin.selectManager': 'Select Admin',
    'admin.noManager': 'No Admin (unassign)',
    'admin.assigningUser': 'Assigning user',
    'admin.assign': 'Assign',
    'admin.assignError': 'Assign admin error',
    'admin.self': 'Self',
    'admin.active': 'Active',
    'admin.used': 'Used',
    'admin.adminPanel': 'Admin Panel',
    'admin.newsManagement': 'News Management',
    'admin.addNews': 'Add News',
    'admin.editNews': 'Edit News',
    'admin.deleteNews': 'Delete News',
    'admin.deleteNewsConfirm': 'Are you sure you want to delete this news article?',
    'admin.newsTitle': 'Title',
    'admin.newsSummary': 'Summary',
    'admin.newsContent': 'Content',
    'admin.newsImageUrl': 'Image URL',
    'admin.newsPublished': 'Published',
    'admin.newsDraft': 'Draft',
    'admin.newsStatus': 'Status',
    'admin.newsCreateSuccess': 'News article created successfully',
    'admin.newsUpdateSuccess': 'News article updated successfully',
    'admin.newsDeleteSuccess': 'News article deleted successfully',

    // Invitation code management
    'admin.invitationManagement': 'Invitation Code Management',
    'admin.createInvitation': 'Create Invitation',
    'admin.invitationCode': 'Invitation Code',
    'admin.invitationCreated': 'Invitation created successfully',
    'admin.copy': 'Copy',
    'admin.codeCopied': 'Code copied to clipboard',
    'admin.noInvitations': 'No invitations found',

    // Authorization request related
    'user.authRequests': 'Authorization Requests',
    'user.authRequestManagement': 'Authorization Request Management',
    'user.createAuthRequest': 'Create Authorization Request',
    'user.authCode': 'Authorization Code',
    'user.authRequestCreated': 'Authorization request created successfully',
    'user.shareAuthLink': 'Share Authorization Link',
    'user.shareAuthLinkHelp': 'Send this link to an admin to authorize them to manage your account',
    'user.linkCopied': 'Link copied to clipboard',
    'user.copyLink': 'Copy Link',
    'user.share': 'Share',
    'user.shareLink': 'Share Link',
    'user.authRequestHelp': 'Create an authorization request to allow an admin to manage your account',
    'user.authRequestShareTitle': 'IoT Battery Management Authorization',
    'user.authRequestShareText': 'Please authorize you as my battery system admin',
    'common.noAuthRequests': 'No authorization requests found',
    'user.pending': 'Pending',
    'user.accepted': 'Accepted',
    'user.rejected': 'Rejected',

    'admin.authRequestReview': 'Authorization Request Review',
    'admin.authRequestDetails': 'Authorization Request Details',
    'admin.authRequestLoadError': 'Failed to load authorization requests',
    'admin.requestCode': 'Request Code',
    'admin.createdBy': 'Created By',
    'admin.processedBy': 'Processed By',
    'admin.processedAt': 'Processed At',
    'admin.unknownUser': 'Unknown User',
    'admin.accept': 'Accept',
    'admin.reject': 'Reject',
    'admin.authRequestAccepted': 'Authorization request accepted successfully',
    'admin.authRequestRejected': 'Authorization request rejected successfully',
    'admin.authRequestNotForAdmin': 'Authorization request management is only applicable to regular users. As an admin, you can review and process authorization requests from users.',

    // Battery pack details
    'battery.packageDetails': 'Battery Pack Details',

    'battery.basicInfo': 'Basic Information',
    'battery.cellCount': 'Cell Count',
    'battery.tempSensorCount': 'Temperature Sensor Count',
    'battery.chargeCurrentStatus': 'Charge Current Status',
    'battery.totalVoltageStatus': 'Total Voltage Status',
    'battery.dischargeCurrentStatus': 'Discharge Current Status',
    'battery.controlStatus': 'Control and Command Status',
    'battery.instructionState': 'Instruction State',
    'battery.controlState': 'Control State',
    'battery.chargerAvailable': 'Charger Available',
    'battery.warningStatus': 'Warning and Fault Status',
    'battery.led_warning': 'LED Warning',
    'battery.buzzer_warning': 'Buzzer Warning',
    'battery.freq_shift': 'Frequency Shift',
    'battery.parallelStatus': 'Parallel Battery System Status',
    'battery.parallelCount': 'Parallel Battery Count',
    'battery.avgCycleCount': 'Average Cycle Count',
    'battery.cycleCountUnit': 'cycles',


    'battery.standby': 'Standby',
    'battery.cellVoltage': 'Cell Voltage',
    'battery.batteryPackUnavailable': 'Battery pack data temporarily unavailable, attempting to display last data...',
    'battery.normalStatus': 'This battery pack is normal, no warnings or faults',
    'battery.warn_high_charge_temp': 'High Charge Temperature',

    // Dashboard new content
    'dashboard.soc': 'SOC',
    'dashboard.voltage': 'Total Voltage',
    'dashboard.current': 'Total Current',
    'dashboard.temperature': 'Highest Temperature',
    'dashboard.systemStatus': 'System Status',
    'dashboard.totalDevices': 'Total Devices',
    'dashboard.onlineDevices': 'Online Devices',
    'dashboard.deviceStatus': 'Device Status',
    'dashboard.batteryStatus': 'Battery Status',
    'dashboard.powerStatus': 'Power Status',
    'dashboard.temperatureStatus': 'Temperature Status',
    'dashboard.avgSOC': 'Average SOC',
    'dashboard.types': 'Types',
    'dashboard.batteryHistory': 'Battery History Data',
    'dashboard.voltageHistory': 'Voltage History',
    'dashboard.currentHistory': 'Current History',
    'dashboard.socHistory': 'SOC History',
    'dashboard.temperatureHistory': 'Temperature History',
    'dashboard.lastHour': 'Last 1 Hour',
    'dashboard.last6Hours': 'Last 6 Hours',
    'dashboard.lastDay': 'Last 24 Hours',
    'dashboard.lastWeek': 'Last Week',
    'dashboard.lastMonth': 'Last Month',
    'dashboard.batteryDetails': 'Battery Details',
    'dashboard.deviceAnalysis': 'Device Analysis',
    'dashboard.systemOverview': 'System Overview',
    'dashboard.deviceTypeDistribution': 'Device Type Distribution',
    'dashboard.voltageAndCurrentOverview': 'Voltage and Current Overview',
    'dashboard.onlinePercentage': 'Online Percentage',
    'dashboard.noAlerts': 'No alert records',

    // Dashboard page specific
    'dashboard.totalInstallations': 'Total Installations',
    'dashboard.viewAllInstallations': 'View All Installations',
    'dashboard.activeInstallations': 'Active Installations',
    'dashboard.allInstallations': 'All Installations',
    'dashboard.systemAlertsNotices': 'System Alerts and Notifications',
    'dashboard.deviceOffline': 'Device Offline',
    'dashboard.deviceOfflineDesc': 'Device {{name}} ({{id}}) is currently offline. Please check the connection.',
    'dashboard.deviceAlarm': 'Device Alert',
    'dashboard.deviceAlarmDesc': 'Device {{name}} ({{id}}) has active alerts. Please check the device status.',
    'dashboard.systemNormal': 'System Normal',
    'dashboard.systemNormalDesc': 'All systems are running normally.',
    'dashboard.latestNews': 'Product News',

    // InstallationList page
    'installations.loadError': 'Failed to load installations. Please try again later.',
    'installations.noInstallations': 'No installations found.',
    'installations.realtime': 'Real-time',
    'installations.oldData': 'Old Data',
    'installations.batteries': 'Batteries',
    'installations.lastUpdate': 'Last Update',
    'installations.deviceName': 'Installation Name (optional)',
    'installations.deviceNamePlaceholder': 'My Battery System',
    'installations.deviceNameHelper': 'Give your device a friendly name',
    'installations.deviceIdRequired': 'Device ID is required',
    'installations.deviceIdPlaceholder': 'Find on WIFI device label',
    'installations.deviceClaimed': 'Device claimed successfully',
    'installations.addFailed': 'Failed to add device',
    'installations.otherType': 'Other',


    // Installation Detail page
    'detail.backToList': 'Back to List',
    'detail.installationDetail': 'Installation Details',
    'detail.installationName': 'Installation Name',
    'detail.owner': 'Owner',
    'detail.batteryCount': 'Battery Count',
    'detail.realtimeMetrics': 'Real-time Metrics',
    'detail.avgSOC': 'Average SOC',
    'detail.avgSOH': 'Average SOH',
    'detail.maxCellVol': 'Max Cell Voltage',
    'detail.minCellVol': 'Min Cell Voltage',
    'detail.cellVolDiff': 'Cell Voltage Difference',

    // Battery Detail page
    'battery.packDetail': 'Battery Pack #{{index}} Details',

    'battery.packNotFound': 'Battery pack data not found',
    'battery.loadError': 'Failed to load battery data',

    // Battery Overview
    'battery.packVoltage': 'Battery Pack Voltage',
    'battery.packCurrent': 'Battery Pack Current',
    'battery.packPower': 'Battery Pack Power',
    'battery.chargerConnected': 'Charger Connected',
    'battery.fullEnergy': 'Full Energy',
    'battery.remainEnergy': 'Remaining Energy',

    'common.yes': 'Yes',
    'common.no': 'No',
    'common.on': 'On',
    'common.off': 'Off',
    'common.ongoing': 'Ongoing',


    // RealTime Monitor
    'battery.cellVoltages': 'Cell Voltages',
    'battery.temperatures': 'Temperature Monitoring',

    // History Charts
    'battery.historyTrends': 'History Trends',
    'battery.voltageCurrent': 'Voltage & Current',

    'battery.dragToSelect': 'Drag to select time range',

    'battery.alarmDetails': 'Alarm Details',
    'battery.noActiveAlarms': 'No active alarms',
    'battery.sensor': 'Sensor',
    'battery.issue': 'Issue',
    'battery.tempSensorIssues': 'Temperature Sensor Issues',

    // Charts & Widgets
    'battery.minCellVoltage': 'Min Cell Voltage',
    'battery.maxCellVoltage': 'Max Cell Voltage',


    'battery.mosTemp': 'MOS Temperature',
    'battery.envTemp': 'Environment Temperature',
    'battery.otherTemps': 'Other Temperatures',


    'battery.noDataAvailable': 'No data available',
    'battery.fetchError': 'Failed to fetch history data',
    'battery.generalError': 'An error occurred',
    'settings.jkReadOnlyNote': 'JK BMS settings are updated automatically via broadcast and are read-only in this system.',
    'settings.lastUpdated': 'Last Updated',

    // Settings - Common
    'settings.recover': 'Recover',
    'settings.delay': 'Delay',
    'settings.unitV': 'Unit: V',
    'settings.unitA': 'Unit: A',
    'settings.unitMs': 'Unit: ms',
    'settings.unitUs': 'Unit: μs',
    'settings.unitC': 'Unit: °C',
    'settings.charge': 'Charge',
    'settings.discharge': 'Discharge',
    'settings.high': 'High',
    'settings.low': 'Low',
    'settings.description': 'Description',
    'settings.read': 'Read',
    'settings.setting': 'Setting...',
    'settings.readSuccess': 'Read successfully',
    'settings.timeout': 'Operation timeout',
    'settings.operationFailed': 'Operation failed',
    'settings.failed': 'Failed',

    // Settings - Control Tab
    'settings.mosControl': 'MOS Control',
    'settings.chargeMosControl': 'Charge MOS Control',
    'settings.openChargeMos': 'Open Charge MOS',
    'settings.closeChargeMos': 'Close Charge MOS',
    'settings.dischargeMosControl': 'Discharge MOS Control',
    'settings.openDischargeMos': 'Open Discharge MOS',
    'settings.closeDischargeMos': 'Close Discharge MOS',
    'settings.powerManagement': 'Power Management',
    'settings.shutdownSleep': 'Shutdown/Sleep',
    'settings.opening': 'Opening...',
    'settings.closing': 'Closing...',
    'settings.executing': 'Executing...',

    // Settings - Protection Tab
    'settings.protGroup1': 'Voltage Protection Parameters',
    'settings.cellOvercharge': 'Cell Overcharge',
    'settings.cellOverchargeDesc': 'When cell voltage continuously exceeds the protection value for the set delay, BMS will immediately execute protection action and force stop charging. After triggering protection, when all cell voltages fall below the recovery value, the system restores charging function.',
    'settings.cellOverdischarge': 'Cell Overdischarge',
    'settings.cellOverdischargeDesc': 'When cell voltage continuously falls below the protection value for the set delay, BMS will immediately execute protection action and force stop discharging. After triggering protection, when all cell voltages rise above the recovery value, the system restores discharging function.',
    'settings.totalOvercharge': 'Total Overcharge',
    'settings.totalOverchargeDesc': 'When total voltage continuously exceeds the protection value for the set delay, BMS will immediately execute protection action and force stop charging. After triggering protection, when all cell voltages fall below the recovery value, the system restores charging function.',
    'settings.totalOverdischarge': 'Total Overdischarge',
    'settings.totalOverdischargeDesc': 'When total voltage continuously falls below the protection value for the set delay, BMS will immediately execute protection action and force stop discharging. After triggering protection, when all cell voltages rise above the recovery value, the system restores discharging function.',

    'settings.protGroup2': 'Current Protection Parameters',
    'settings.chargeOvercurrent': 'Charge Overcurrent',
    'settings.chargeOvercurrentDesc': 'The warning value is the maximum charge current requested from the inverter. When charge current continuously exceeds the protection value for the set delay, BMS will immediately execute protection action and force stop charging.',
    'settings.dischargeOvercurrent1': 'Discharge Overcurrent 1',
    'settings.dischargeOvercurrent1Desc': 'The warning value is the maximum discharge current requested from the inverter. When discharge current continuously exceeds the protection value for the set delay, BMS will immediately execute protection action and force stop discharging.',
    'settings.dischargeOvercurrent2': 'Discharge Overcurrent 2',
    'settings.dischargeOvercurrent2Desc': 'When discharge current continuously exceeds the protection value for the set delay, BMS will immediately execute protection action and force stop discharging.',
    'settings.maxChargeCurrent': 'Charge Current Limit',
    'settings.maxChargeCurrentDesc': 'The Charge Current Limit (CCL) refers to the maximum allowable charging current that a single battery module reports to the inverter under normal operating conditions. When N battery modules are connected in parallel, the total maximum charging current requested by the battery system to the inverter is the sum of the individual module CCLs, i.e. CCL × N. \nThe protection value refers to the current threshold at which a single battery module triggers overcurrent protection. The CCL must be set lower than the protection value.',
    'settings.maxDischargeCurrent': 'Discharge Current Limit',
    'settings.maxDischargeCurrentDesc': 'The Discharge Current Limit (DCL) refers to the maximum allowable discharging current that a single battery module reports to the inverter under normal operating conditions. When N battery modules are connected in parallel, the total maximum discharging current requested by the battery system to the inverter is the sum of the individual module DCLs, i.e. DCL × N. \nThe protection value refers to the current threshold at which a single battery module triggers overcurrent protection. The DCL must be set lower than the protection value.',
    'settings.maxChargeVoltage': 'Charging Voltage Limit',
    'settings.maxChargeVoltageDesc': 'The Charging Voltage Limit (CVL) is the maximum total voltage requested by the battery system from the inverter.',
    'settings.chargeVoltageLimitV': 'CVL (V)',
    'settings.chargeCurrentLimitA': 'CCL (A)',
    'settings.dischargeCurrentLimitA': 'DCL (A)',
    'settings.shortCircuitDesc': 'When short circuit is detected for the set delay, BMS will immediately execute protection action and force stop charging and discharging.',

    'settings.protGroup3': 'Temperature Protection Parameters',
    'settings.tempHigh': 'High Temperature Protection',
    'settings.tempHighDesc': 'When temperature exceeds the protection value, BMS will immediately execute protection action and force stop charging or discharging. After triggering protection, when temperature falls below the recovery value, the system restores charging or discharging function.',
    'settings.tempLow': 'Low Temperature Protection',
    'settings.tempLowDesc': 'When temperature falls below the protection value, BMS will immediately execute protection action and force stop charging or discharging. After triggering protection, when temperature rises above the recovery value, the system restores charging or discharging function. When temperature falls below the charge warning value, heating function automatically turns on. When temperature rises to the charge recovery value, heating function automatically turns off.',
    'settings.mosTempHigh': 'MOS High Temperature Protection',
    'settings.mosTempHighDesc': 'When MOS temperature is higher than the protection value, BMS immediately executes protection action and force stops charging and discharging. After triggering protection, when MOS temperature falls below the recovery value, the system restores charging or discharging function.',
    'settings.envTemp': 'Environment Temperature Protection',
    'settings.envTempDesc': 'When environment temperature exceeds the high temperature protection value or falls below the low temperature protection value, BMS will immediately execute protection action and force stop charging or discharging. After triggering protection, when environment temperature returns to the corresponding recovery temperature range, the system will automatically restore charging or discharging function.',
    'settings.chargeHighTemp': 'Charge High Temp',
    'settings.chargeHighTempRecovery': 'Charge High Temp Recovery',
    'settings.dischargeHighTemp': 'Discharge High Temp',
    'settings.dischargeHighTempRecovery': 'Discharge High Temp Recovery',
    'settings.balanceStartVoltage': 'Balance Start Voltage',
    'settings.balanceTriggerDiff': 'Balance Trigger Diff',
    'settings.balanceMaxCurrent': 'Max Balance Current',
    'settings.designCapacity': 'Design Capacity',

    // JK BMS settings block titles and fields
    'settings.temperatureHighProtection': 'High Temperature Protection',
    'settings.temperatureLowProtection': 'Low Temperature Protection',
    'settings.mosTempHighProtection': 'MOS High Temperature Protection',
    'settings.balanceParams': 'Balance Parameters',
    'settings.protection': 'Protection',
    'settings.chargeLowTemp': 'Charge Low Temp',
    'settings.dischargeLowTemp': 'Discharge Low Temp',
    'settings.dischargeLowTempRecovery': 'Discharge Low Temp Recovery',

    'common.enabled': 'Enabled',

    // JK BMS Settings - Pack Voltage Protection
    'jk.noSettingsData': 'No settings data received yet. Settings are updated when the BMS broadcasts a SETUP frame.',
    'jk.chargeVoltages': 'Charge Voltages',
    'jk.socSettings': 'SOC Settings',
    'jk.packVoltageProtection': 'Pack Voltage Protection',
    'jk.packOVP': 'Float Charge Voltage',
    'jk.packUVP': 'Inverter Max Charge Voltage',
    'jk.floatVoltage': 'Float Charge Voltage',
    'jk.inverterMaxChargeVoltage': 'Inverter Max Charge Voltage',
    'jk.soc100Voltage': 'SOC 100% Voltage',
    'jk.soc0Voltage': 'SOC 0% Voltage',
    'jk.smartSleepVoltage': 'Smart Sleep Voltage',
    'jk.autoPowerOffVoltage': 'Auto Power Off Voltage',
    // JK BMS Settings - Current Protection
    'jk.currentProtection': 'Current Protection',
    'jk.chargeOC': 'Charge Current Limit',
    'jk.chargeOCPDelay': 'Charge OCP Delay',
    'jk.chargeOCPRelease': 'Charge OCP Release',
    'jk.dischargeOC': 'Discharge Current Limit',
    'jk.dischargeOCPDelay': 'Discharge OCP Delay',
    'jk.dischargeOCPRelease': 'Discharge OCP Release',
    'jk.scpRelease': 'SCP Release Delay',
    // JK BMS Settings - Battery Configuration
    'jk.batteryConfig': 'Battery Configuration',
    'jk.cellCount': 'Cell Count',
    'jk.chargeSwitch': 'Charge Switch',
    'jk.dischargeSwitch': 'Discharge Switch',
    'jk.balanceSwitch': 'Balance Switch',
    'jk.scpDelay': 'SCP Delay',
    // JK BMS Settings - Device Configuration
    'jk.deviceConfig': 'Device Configuration',
    'jk.deviceAddress': 'Device Address',
    'jk.prechargeDelay': 'Precharge Delay',
    'jk.smartSleepTime': 'Smart Sleep Time',
    'jk.heatEnabled': 'Heating',
    'jk.tempSensorDisabled': 'Temp Sensor Disabled',
    'jk.gpsHeartbeat': 'GPS Heartbeat',
    'jk.portSwitch': 'Port (RS485)',
    'jk.lcdAlwaysOn': 'LCD Always On',
    'jk.specialCharger': 'Special Charger',
    'jk.smartSleepEnabled': 'Smart Sleep',
    'jk.disablePCLModule': 'Disable PCL Module',
    'jk.timedStoredData': 'Timed Data Storage',
    'jk.chargingFloatMode': 'Charging Float Mode',

    'settings.enableProtection': 'Enable Protection',
    'settings.chargeTempProt': 'Charge Temperature Protection',
    'settings.dischargeTempProt': 'Discharge Temperature Protection',

    // Settings - History Tab
    'settings.historyManagement': 'History Record Management',
    'settings.reading': 'Reading...',
    'settings.readHistory': 'Read all history records (1-40)',
    'settings.stopReading': 'Stop Reading',
    'settings.clearHistory': 'Clear History Records',
    'settings.messages.historyReadComplete': 'History record reading complete! Total {{count}} records read',
    'settings.historyRecords': 'History Records ({{count}} records)',
    'settings.record': 'Record {{index}}',
    'settings.timeUnknown': 'Unknown Time',
    'settings.cellInfo': 'Cell Information ({{count}} cells)',
    'settings.tempSensors': 'Temperature Sensors ({{count}} sensors)',
    'settings.statusInfo': 'Status Information',
    'settings.noHistoryFound': 'No history records found',
    'settings.clearHistoryResult': 'Clear history records result',
    'settings.confirmClearHistory': 'Confirm Clear History',
    'settings.confirmClearHistoryDesc': 'Are you sure you want to delete all history records from the BMS?',
    'settings.clearHistoryWarning': 'This operation will permanently delete all history record data from the BMS device and cannot be recovered.',
    'settings.confirmDelete': 'Confirm Delete',

    // Settings - Protocol Tab
    'settings.inverterProtocolConfig': 'Inverter Protocol Configuration',
    'settings.protocolSelectDesc': 'After reading the inverter protocol list, select the inverter protocol you are using from the dropdown.',



    'settings.canProtocol': 'CAN Protocol',
    'settings.rs485Protocol': 'RS485 Protocol',
    'settings.selectCanProtocol': 'Select CAN Protocol',
    'settings.selectRs485Protocol': 'Select RS485 Protocol',

    // Settings - System Tab
    'settings.mainBatterySettings': 'Master Pack Settings',
    'settings.systemConfig': 'Battery Configuration',
    'settings.otherConfig': 'Other Settings',
    'settings.timeSettings': 'Time Settings',
    'settings.timeSettingsDesc': 'BMS internal time, used for displaying and recording data. Syncing with local time makes it easier to track data.',
    'settings.syncTime': 'Sync Local Time',
    'settings.bmsTime': 'BMS Time',
    'settings.capacitySettings': 'Capacity Settings',
    'settings.capacitySettingsDesc': 'Modifying the remaining capacity setting affects the SOC percentage display. Design capacity is the battery\'s nominal capacity at factory, and full charge capacity indicates the current actual capacity of the battery, which decreases with usage time and cycle count.',
    'settings.batterySeries': 'Series Count Settings',
    'settings.batterySeriesDesc': 'The system default cell series count is 16. When the actual cell series count is less than 16, adjust it here to the corresponding actual value.',
    'settings.batterySeriesHelper': 'Series cell count',
    'settings.cycleCount': 'Cycle Count Settings',
    'settings.cycleCountDesc': 'Cycle count automatically accumulates during battery charge/discharge process, and supports manual adjustment here.',
    'settings.cycleCountHelper': 'Battery charge/discharge cycle count',
    'settings.fullChargeParams': 'Full Charge Parameters',
    'settings.fullChargeParamsDesc': 'Set full charge determination conditions. When battery voltage and current simultaneously meet the cutoff conditions, BMS determines the battery is fully charged. Low capacity alarm is used to set the SOC low power prompt threshold.',
    'settings.fullChargeCutoffVoltage': 'Full Charge Cutoff Voltage (V)',
    'settings.fullChargeCutoffCurrent': 'Full Charge Cutoff Current (A)',
    'settings.lowCapacityAlarm': 'Low Capacity Alarm (%)',
    'settings.capacityRelease': 'Capacity Release Settings',
    'settings.capacityReleaseDesc': 'Set Command (Set): A5\nSet the SOC threshold for capacity release.',
    'settings.socValue': 'SOC Value (%)',
    'settings.socRange': 'Range: 74-97',
    'settings.currentZero': 'Current Zero Calibration',
    'settings.currentZeroDesc': 'Command: AA\nCalibrate current sensor zero point when there is no current. Can input correction value (default is 0).',
    'settings.correctionValue': 'Correction Value (0.1A)',
    'settings.refVoltage': 'Reference Voltage Calibration',
    'settings.refVoltageDesc': 'Command: A9\nCalibrate battery pack reference voltage (usually refers to cell voltage sampling reference). Input the measured actual voltage value (mV).',
    'settings.actualVoltageMv': 'Actual Voltage (mV)',
    'settings.totalVoltage': 'Total Voltage Calibration',
    'settings.totalVoltageDesc': 'Input the actual battery voltage measured by multimeter or other measuring equipment here, which can be used to calibrate the voltage value displayed by BMS.',
    'settings.actualTotalVoltageMv': 'Actual Total Voltage (mV)',
    'settings.chargeCurrent': 'Charge Current Calibration',
    'settings.chargeCurrentDesc': 'Command: AC\nCalibrate charge current. Input the actual measured charge current value (A). System will automatically convert to 0.1A unit.',
    'settings.actualCurrentA': 'Actual Current (A)',
    'settings.dischargeCurrent': 'Discharge Current Calibration',
    'settings.dischargeCurrentDesc': 'Command: AB\nCalibrate discharge current. Input the actual measured discharge current value (A). System will automatically convert to 0.1A unit.',
    'settings.systemInfo': 'System Information',
    'settings.versionInfo': 'Version Information',
    'settings.versionInfoDesc': 'BMS firmware version.',
    'settings.internalVersion': 'Firmware Version',
    'settings.internalVersionHelper': 'Internal version information',
    'settings.restoreDefault': 'Restore Default',
    'settings.restoreDefaultDesc': 'This operation will restore all parameters to BMS factory default values.',
    'settings.restoreDefaultBtn': 'Restore Default Parameters',
    'settings.restoring': 'Restoring...',

    // Settings - Permissions Tab
    'settings.permissionsDesc': 'Grant other users permission to view or control this installation.',
    'settings.shareSuccess': 'Successfully shared with {{email}}',
    'settings.shareFailed': 'Failed to share installation',
    'settings.removeAccessSuccess': 'Permission removal successful',
    'settings.removeAccessFailed': 'Failed to remove permission',
    'settings.loadingUsers': 'Loading users...',
    'settings.noSharedUsers': 'No users have been granted access yet.',
    'settings.noPermission': 'You do not have permission to manage this installation. Only the owner can share the installation.',
    'settings.userEmail': 'User Email',
    'settings.accessLevel': 'Access Level',
    'settings.readOnly': 'Read Only',
    'settings.readWrite': 'Read Write',
    'settings.sharing': 'Sharing...',
    'settings.shareDevice': 'Share Installation',
    'settings.usersWithAccess': 'Users with Access',
    'settings.remove': 'Remove',

    // Settings - SettingsLogTab
    'settings.modificationLog': 'Settings Modification Log',
    'settings.loadHistoryFailed': 'Failed to load history records',
    'settings.noChangesFound': 'No changes found',
    'settings.logSetting': 'Setting Item',
    'settings.na': 'N/A',

    // Settings - Params Mapping (Log Types)
    'settings.enabled': 'Enabled',
    'settings.controlMode': 'Control Mode',
    'settings.delayMs': 'Delay (ms)',
    'settings.unknown': 'Unknown',
    'settings.alarmVoltage': 'Alarm (mV)',
    'settings.chargeAlarmVoltage': 'Charge Alarm (mV)',
    'settings.dischargeAlarmVoltage': 'Discharge Alarm (mV)',
    'settings.protectionVoltage': 'Protection (mV)',
    'settings.recoveryVoltage': 'Recovery (mV)',
    'settings.alarmVoltageV': 'Alarm (V)',
    'settings.protectionVoltageV': 'Protection (V)',
    'settings.recoveryVoltageV': 'Recovery (V)',
    'settings.alarmCurrentA': 'Alarm (A)',
    'settings.protectionCurrentA': 'Protection (A)',
    'settings.recoveryCurrentA': 'Recovery (A)',
    'settings.chargeProtectionCurrentA': 'Charge Protection (A)',
    'settings.delayUs': 'Delay (μs)',
    'settings.alarmCurrentMa': 'Alarm (mA)',
    'settings.protectionCurrentMa': 'Protection (mA)',
    'settings.recoveryCurrentMa': 'Recovery (mA)',
    'settings.alarmTemp': 'Alarm (°C)',
    'settings.protectionTemp': 'Protection (°C)',
    'settings.recoveryTemp': 'Recovery (°C)',
    'settings.chargeHighTempAlarm': 'Charge High Temperature Alarm (°C)',
    'settings.chargeHighTempProtection': 'Charge High Temperature Protection (°C)',
    'settings.dischargeHighTempAlarm': 'Discharge High Temperature Alarm (°C)',
    'settings.chargeLowTempAlarm': 'Charge Low Temperature Alarm (°C)',
    'settings.chargeLowTempProtection': 'Charge Low Temperature Protection (°C)',
    'settings.chargeLowTempRecovery': 'Charge Low Temperature Recovery (°C)',
    'settings.dischargeLowTempAlarm': 'Discharge Low Temperature Alarm (°C)',
    'settings.envLowTempProtection': 'Environment Low Temperature Protection (°C)',
    'settings.envLowTempRecovery': 'Environment Low Temperature Recovery (°C)',
    'settings.socPercent': 'SOC (%)',
    'settings.sleepVoltageMv': 'Sleep Voltage (mV)',
    'settings.sleepDelayMin': 'Sleep Delay (min)',
    'settings.chargeDelayMs': 'Charge Delay (ms)',
    'settings.chargeProtectionCurrentMa': 'Charge Protection Current (mA)',
    'settings.dischargeDelayMs': 'Discharge Delay (ms)',

    // Balance Settings
    'settings.balance': 'Active Balancing Settings',
    'settings.balanceDesc': 'Set the start voltage for active balancing. Active balancing turns on when cell voltage is greater than the start voltage, and turns off when it is lower.',
    'settings.balanceStartDiff': 'Start Difference',
    'settings.balanceStartVoltageMv': 'Start Voltage (mV)',
    'settings.balanceStartDiffMv': 'Start Diff (mV)',

    // Setting Types













    'settings.fullCharge': 'Full Charge Settings',
    'settings.cellSleep': 'Cell Sleep',
    'settings.cellSleepDesc': 'When cell voltage falls below sleep voltage for longer than the delay time, the battery will enter sleep mode to conserve power.',
    'settings.inverterProtocol': 'Inverter Protocol',

    // InstallationSettings Main Page
    'settings.title': 'Installation Settings',

    'settings.sendCommandFailed': 'Failed to send command',
    'settings.confirmShutdown': 'Confirm Shutdown/Sleep',
    'settings.confirmShutdownDesc': 'Are you sure you want to shut down or put the battery to sleep? After shutting down, you need to go to the battery installation site to manually start it.',

    // Tabs
    'settings.tabs.control': 'Control',
    'settings.tabs.protection': 'Protection Settings',
    'settings.tabs.protocol': 'Protocol Settings',
    'settings.tabs.system': 'System Settings',
    'settings.tabs.log': 'Settings Log',

    // Messages
    'settings.messages.fetchingProtocolSettings': 'Fetching current protocol settings...',
    'settings.messages.fetchProtocolListFailed': 'Failed to fetch inverter protocol list',
    'settings.messages.fetchingHistory': 'Reading history records...',
    'settings.messages.startReadingHistory': 'Starting to read history records...',
    'settings.messages.readingHistoryProgress': 'Reading record {{current}}/{{total}}...',
    'settings.messages.protocolSetSuccess': 'Protocol set successfully',
    'settings.messages.protocolListSuccess': 'Protocol list retrieved successfully',
    'settings.messages.protocolListComplete': 'Protocol list fetch complete! Found {{count}} protocols',
    'settings.messages.protocolListCompleteCan': 'Protocol list fetch complete! Found {{count}} CAN protocols',
    'settings.messages.fetchingProtocolIds': 'Fetching protocol ID list...',
    'settings.messages.fetchingCanNames': 'Fetching CAN protocol names...',
    'settings.messages.fetchingRs485Names': 'Fetching RS485 protocol names...',



    // Support System
    'support.title': 'Technical Support',
    'support.newPost': 'New Post',
    'support.editPost': 'Edit Post',
    'support.searchPlaceholder': 'Search posts...',
    'support.filterByTag': 'Filter by Tag',
    'support.allTags': 'All Tags',
    'support.products': 'Products',
    'support.categories': 'Categories',
    'support.sortBy': 'Sort By',
    'support.sortLatest': 'Latest',
    'support.sortPopular': 'Popular',
    'support.sortUnsolved': 'Unsolved',
    'support.sortMostViewed': 'Most Viewed',
    'support.loadError': 'Failed to load posts',
    'support.noSearchResults': 'No matching posts found',
    'support.noPosts': 'No posts yet',
    'support.createFirstPost': 'Create first post',
    'support.minutesAgo': '{{count}} minutes ago',
    'support.hoursAgo': '{{count}} hours ago',
    'support.daysAgo': '{{count}} days ago',
    'support.pinned': 'Pinned',
    'support.locked': 'Locked',
    'support.resolved': 'Resolved',
    'support.private': 'Private',
    'support.views': 'Views',
    'support.replies': 'Replies',
    'support.noReplies': 'No replies yet',
    'support.backToList': 'Back to List',
    'support.postNotFound': 'Post not found',
    'support.accessDenied': 'Access denied',
    'support.addReply': 'Add Reply',
    'support.replyPlaceholder': 'Enter your reply...',
    'support.submitReply': 'Submit Reply',
    'support.loginToReply': 'Login to reply',
    'support.postLocked': 'Post is locked, cannot reply',
    'support.bestAnswer': 'Best Answer',
    'support.markBestAnswer': 'Mark as Best Answer',
    'support.unmarkBestAnswer': 'Unmark Best Answer',
    'support.confirmDelete': 'Confirm Delete',
    'support.confirmDeletePost': 'Are you sure you want to delete this post?',
    'support.confirmDeleteReply': 'Are you sure you want to delete this reply?',
    'support.pin': 'Pin',
    'support.unpin': 'Unpin',
    'support.lock': 'Lock',
    'support.unlock': 'Unlock',
    'support.statusOpen': 'Unsolved',
    'support.statusResolved': 'Resolved',
    'support.statusClosed': 'Closed',
    'support.postTitle': 'Post Title',
    'support.titlePlaceholder': 'Briefly describe your issue',
    'support.postContent': 'Content',
    'support.contentPlaceholder': 'Describe your issue or suggestion in detail...',
    'support.selectProduct': 'Select Product',
    'support.noProduct': 'None',
    'support.selectCategory': 'Select Category',
    'support.categoryRequired': 'Please select a category',
    'support.announcementAdminOnly': 'Only admins can post announcements',
    'support.titleContentRequired': 'Title and content cannot be empty',
    'support.linkDevice': 'Link Device',
    'support.linkDeviceDescription': 'Link a device to share its current status snapshot and settings with support staff.',
    'support.selectDevice': 'Select Device',
    'support.noDevice': 'None',
    'support.packIndex': 'Battery Pack Index',
    'support.linkedDeviceSnapshot': 'Linked Device Status Snapshot',
    'support.linkedDeviceSettings': 'Linked Device Settings Snapshot',
    'support.publicPost': 'Public Post',
    'support.privatePost': 'Private Post',
    'support.publicDescription': 'Everyone can see this post',
    'support.privateDescription': 'Only you and admins can see this post',
    'support.submitPost': 'Submit Post',
    'support.saveDraft': 'Save Draft',
    'support.draftSaved': 'Draft saved',
    'support.similarPostsFound': 'Similar posts found, maybe already answered:',
    'support.createError': 'Failed to create post',

    // Phase 2 additions
    'support.myPosts': 'My Posts',
    'support.myPostsTab': 'My Posts',
    'support.draftsTab': 'Drafts',
    'support.noMyPosts': 'You haven\'t posted anything yet',
    'support.untitledDraft': 'Untitled Draft',
    'support.lastSaved': 'Last saved',
    'support.continueDraft': 'Continue Editing',
    'support.deleteDraft': 'Delete Draft',
    'support.noDrafts': 'No saved drafts',
    'support.addImages': 'Add Images',
    'support.maxFilesError': 'Maximum {{max}} images allowed',
    'support.onlyImagesAllowed': 'Only image files are allowed',
    'support.fileTooLarge': 'File too large (max 10MB)',
    'support.uploadFailed': 'Upload failed',
    'common.uploadImages': 'Upload Images',

    // Phase 3 additions
    'support.mentioning': 'Mentioning',

    // Phase 4 additions
    'support.adminPanel': 'Support Management',
    'support.tagsTab': 'Tag Management',
    'support.templatesTab': 'Reply Templates',
    'support.reportsTab': 'Report Management',
    'support.addTag': 'Add Tag',
    'support.editTag': 'Edit Tag',
    'support.tagType': 'Tag Type',
    'support.tagColor': 'Tag Color',
    'support.confirmDeleteTag': 'Are you sure you want to delete this tag?',
    'support.addTemplate': 'Add Template',
    'support.editTemplate': 'Edit Template',
    'support.templateContent': 'Template Content',
    'support.templatePreview': 'Preview',
    'support.templatePlaceholder': 'Supports Markdown format...',
    'support.noTemplates': 'No templates',
    'support.confirmDeleteTemplate': 'Are you sure you want to delete this template?',
    'support.useTemplate': 'Use Template',
    'support.loadTemplatesError': 'Failed to load templates',
    'support.filterStatus': 'Filter Status',
    'support.reportedContent': 'Reported Content',
    'support.reportReason': 'Report Reason',
    'support.reporter': 'Reporter',
    'support.reportPending': 'Pending',
    'support.reportReviewed': 'Reviewed',
    'support.reportDismissed': 'Dismissed',
    'support.markReviewed': 'Mark as Reviewed',
    'support.dismissReport': 'Dismiss Report',
    'support.noReports': 'No reports',

    // API Keys
    'apiKeys.menuTitle': 'API Keys',
    'apiKeys.title': 'API Keys',
    'apiKeys.description': 'Manage access keys for third-party integrations',
    'apiKeys.usageWarning': 'Use API Keys to authenticate external applications like Home Assistant or Grafana without needing to login. Keep your keys secret!',
    'apiKeys.myKeys': 'My Keys',
    'apiKeys.generateKey': 'Generate Key',
    'apiKeys.keyName': 'Name',
    'apiKeys.created': 'Created',
    'apiKeys.lastUsed': 'Last Used',
    'apiKeys.noKeys': 'No API keys found',
    'apiKeys.integrationExamples': 'Integration Examples',
    'apiKeys.haTitle': 'Home Assistant (REST Sensor)',
    'apiKeys.haInstructions': 'Add this to your configuration.yaml:',
    'apiKeys.curlTitle': 'cURL / Terminal',
    'apiKeys.generateDialogTitle': 'Generate API Key',
    'apiKeys.keyNameLabel': 'Key Name (e.g., Home Assistant)',
    'apiKeys.generateAction': 'Generate',
    'apiKeys.successDialogTitle': 'API Key Generated',
    'apiKeys.copyWarning': 'Copy this key now. You won\'t be able to see it again!',
    'apiKeys.createError': 'Failed to create API key',
    'apiKeys.deleteError': 'Failed to delete key',
    'apiKeys.loadError': 'Failed to load API keys',
    
    // Settings
    'settings.deleteAccount': 'Delete Account',
    'settings.deleteAccountDesc': 'Once you delete your account, there is no going back. Please be certain.',
    'settings.deleteAccountConfirm': 'Are you sure you want to delete your account?',
    'settings.deleteAccountWarning': 'This action is permanent and cannot be undone.',
    'settings.deleteAccountSuccess': 'Account deleted successfully',
  },
  // App specific
};

export default en;
